import React from 'react';

import SCIsOverall from '../../components/Monitoring/SCIs/SCIsOverall/SCIsOverall.module';

function SCIsOverallView() {
  return (
    <SCIsOverall />
  );
}

export default SCIsOverallView;


